import { useContext } from 'react';
import UserContext from './user-context';

const useUser = () => useContext(UserContext);

export default useUser;